import { render, staticRenderFns } from "./demoImg.vue?vue&type=template&id=ad1e7388&scoped=true"
import script from "./demoImg.vue?vue&type=script&lang=js"
export * from "./demoImg.vue?vue&type=script&lang=js"
import style0 from "./demoImg.vue?vue&type=style&index=0&id=ad1e7388&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1e7388",
  null
  
)

export default component.exports